import styled from "styled-components";

export const Image = styled.img`
  min-width: 100%;
  height: 100%;
  object-fit: ${props => props.fit};
  object-position: top;

`;
